document.addEventListener("DOMContentLoaded", () => {
    const {
        bgColor,
        phoneCountry,
        csrfToken,
        processOpenBankingRoute,
        btnLabel,
        openBankingBtnLabel,
        directDebitBtnLabel,
        btnProcessingLabel,
        bypassRecaptcha,
        isRequiredCustomerAddress,
        isRequiredCustomerPostCode,
        dataSiteKey,
    } = window.config;

    const paymentFailedModalEl = document.getElementById("paymentFailedModal");
    const paymentFailedModal = new bootstrap.Modal(paymentFailedModalEl, {
        backdrop: "static",
        keyboard: false,
    });

    // Making placeholder star specifically red
    document.querySelectorAll(".holder-txt").forEach((placeholder) => {
        placeholder.addEventListener("click", () => {
            const input = placeholder.parentElement.querySelector("input");
            if (input) input.focus();
        });
    });
    document.querySelectorAll(".number-field").forEach((input) => {
        const placeholder = input.parentElement.querySelector(".holder-txt");

        const togglePlaceholder = () => {
            if (placeholder) {
                placeholder.style.display =
                    input.value.trim() === "" ? "" : "none";
            }
        };

        input.addEventListener("focus", togglePlaceholder);
        input.addEventListener("input", togglePlaceholder); // hide when user types
        input.addEventListener("blur", togglePlaceholder);

        // Initial state on page load
        togglePlaceholder();
    });
    // End Making placeholder star specifically red

    // Payment method toggle
    const payByCardRadio = document.getElementById("payByCard");
    const payByBankRadio = document.getElementById("payByBank");
    const directDebitRadio = document.getElementById("directDebit");

    const payByCardDiv = document.getElementById("card_payment");
    const payByBankDiv = document.getElementById("bank_payment");
    const directDebitDiv = document.getElementById("direct_debit");

    const blinkFormWrapper = document.getElementById("blinkPageForm"); // might be null

    const fieldCustomerAddress = document.querySelector(
        'input[name="customerAddress"]',
    );
    const fieldCustomerPostCode = document.querySelector(
        'input[name="customerPostCode"]',
    );

    const paymentMethodRadios = document.querySelectorAll(
        'input[name="payment_method"]',
    );
    const nameField = document.querySelector('input[name="customerName"]');
    const emailField = document.querySelector('input[name="customerEmail"]');
    const descriptionField = document.querySelector('input[name="orderRef"]');
    const btnSubmit = document.querySelector("#btnSubmit");
    const failureMessage =
        paymentFailedModalEl.querySelector("#failure-message");

    if (paymentMethodRadios.length > 0) {
        function toggleTargetDiv() {
            const nonCardCurrency =
                document.getElementById("non_card_currency");
            const cardCurrency = document.getElementById("card_currency");
            const openBankingCurrency = document.getElementById(
                "open_banking_currency",
            );
            if (payByCardRadio?.checked) {
                payByCardDiv && (payByCardDiv.style.display = "block");
                payByBankDiv && (payByBankDiv.style.display = "none");
                directDebitDiv && (directDebitDiv.style.display = "none");
                blinkFormWrapper?.classList.remove("change-layout");

                btnSubmit.innerHTML = btnLabel;
                btnSubmit.type = "submit";
                btnSubmit.id = "btnSubmit";
                btnSubmit.classList.add("g-recaptcha");
                btnSubmit.setAttribute("data-sitekey", dataSiteKey);
                btnSubmit.setAttribute("data-callback", "onSubmit");
                if (isRequiredCustomerAddress) {
                    fieldCustomerAddress?.setAttribute("required", "required");
                }
                if (isRequiredCustomerPostCode) {
                    fieldCustomerPostCode?.setAttribute("required", "required");
                }
                nameField.setAttribute("required", "required");
                emailField.setAttribute("required", "required");
                if (nonCardCurrency) {
                    nonCardCurrency.classList.add("d-none");
                }

                if (cardCurrency) {
                    cardCurrency.classList.remove("d-none");
                }

                if (openBankingCurrency) {
                    openBankingCurrency.classList.add("d-none");
                }
            } else if (payByBankRadio?.checked) {
                payByCardDiv && (payByCardDiv.style.display = "none");
                payByBankDiv && (payByBankDiv.style.display = "block");
                directDebitDiv && (directDebitDiv.style.display = "none");
                blinkFormWrapper?.classList.add("change-layout");

                btnSubmit.disabled = false;
                btnSubmit.innerHTML = openBankingBtnLabel;
                btnSubmit.type = "submit";
                btnSubmit.id = "btnSubmit";
                btnSubmit.classList.add("g-recaptcha");
                btnSubmit.setAttribute("data-sitekey", dataSiteKey);
                btnSubmit.setAttribute("data-callback", "onSubmit");
                fieldCustomerAddress?.removeAttribute("required");
                fieldCustomerPostCode?.removeAttribute("required");
                nameField.setAttribute("required", "required");
                emailField.setAttribute("required", "required");
                if (nonCardCurrency) {
                    nonCardCurrency.classList.add("d-none");
                }

                if (cardCurrency) {
                    cardCurrency.classList.add("d-none");
                }

                if (openBankingCurrency) {
                    openBankingCurrency.classList.remove("d-none");
                }
            } else if (directDebitRadio?.checked) {
                payByCardDiv && (payByCardDiv.style.display = "none");
                payByBankDiv && (payByBankDiv.style.display = "none");
                directDebitDiv && (directDebitDiv.style.display = "block");
                blinkFormWrapper?.classList.add("change-layout");

                btnSubmit.disabled = false;
                btnSubmit.innerHTML = directDebitBtnLabel;
                btnSubmit.type = "button";
                btnSubmit.id = "paybydirectdebit";
                btnSubmit.classList.remove("g-recaptcha");
                btnSubmit.removeAttribute("data-sitekey");
                btnSubmit.removeAttribute("data-callback");
                nameField.removeAttribute("required");
                emailField.removeAttribute("required");

                fieldCustomerAddress?.removeAttribute("required");
                fieldCustomerPostCode?.removeAttribute("required");
                if (nonCardCurrency) {
                    nonCardCurrency.classList.remove("d-none");
                }

                if (cardCurrency) {
                    cardCurrency.classList.add("d-none");
                }

                if (openBankingCurrency) {
                    openBankingCurrency.classList.add("d-none");
                }
            }
        }

        // Attach change listeners safely
        paymentMethodRadios.forEach((radio) =>
            radio.addEventListener("change", toggleTargetDiv),
        );

        // Initialize state
        toggleTargetDiv();
    }

    //Desktop/Mobile view switcher
    const toggleViewBtn = document.querySelector(".toggle-view-btn");
    const mainDiv = document.querySelector(".my-blink-main");
    if (toggleViewBtn && mainDiv) {
        const btnText = toggleViewBtn.querySelector(".btn-text");

        toggleViewBtn.addEventListener("click", (e) => {
            e.preventDefault();

            mainDiv.classList.toggle("mobile-view");

            if (mainDiv.classList.contains("mobile-view")) {
                btnText.textContent = "Desktop";
            } else {
                btnText.textContent = "Mobile";
            }
        });
    }

    //Color picker modal
    let colorPickerInstance;
    const colorPickerModal = document.querySelector("#changeBgColorModal");
    const colorPickerContainer = document.querySelector(
        "#colorPickerContainer",
    );
    // Only initialize if both exist
    if (colorPickerModal && colorPickerContainer && typeof $ !== "undefined") {
        $("#changeBgColorModal").on("shown.bs.modal", function () {
            if (!colorPickerInstance) {
                colorPickerInstance = $("#colorPickerContainer")
                    .colorpicker({
                        inline: true,
                        container: true,
                        format: "hex",
                        color: bgColor,
                    })
                    .on("colorpickerChange", function (e) {
                        console.log(
                            "New color selected:",
                            e.color.toHexString(),
                        );
                    });
            }
        });
    }

    //Time picker
    // Check if jQuery and the timepicker plugin are loaded
    if (typeof $ !== "undefined" && $.fn.timepicker) {
        const $timeInputs = $(".shop_time");

        if ($timeInputs.length > 0) {
            $timeInputs.timepicker({
                timeFormat: "g:i A", // 12-hour format without leading zero
                scrollDefault: "9:00 AM",
                change: function (time) {
                    // Ensure AM/PM stays uppercase
                    $(this).val(
                        $(this).timepicker("format", time, {
                            timeFormat: "g:i A",
                        }),
                    );
                },
            });
        }
    }

    //Open-close toggle
    if (typeof $ !== "undefined") {
        const $checkboxes = $(".openClose input[type='checkbox']");

        if ($checkboxes.length > 0) {
            $checkboxes.each(function () {
                $(this).on("change", function () {
                    const isChecked = $(this).is(":checked");
                    const $externalLabel = $(this)
                        .closest(".openClose")
                        .find(".label-txt span");

                    if ($externalLabel.length > 0) {
                        $externalLabel.text(isChecked ? "Open" : "Close");
                    }
                });
                $(this).trigger("change");
            });
        }
    }

    //Country select intlTelInput
    if (typeof window.intlTelInput !== "undefined") {
        const phoneInput = document.querySelector("#shop_info_phone");
        window.itiPhone = null;
        // Helper function to initialize phone inputs safely
        const initIntlTelInput = (input) => {
            window.itiPhone = window.intlTelInput(input, {
                initialCountry: phoneCountry,
                loadUtils: () =>
                    import("https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js"),
            });
        };
        if (phoneInput) initIntlTelInput(phoneInput);
    }
    //End Country select intlTelInput

    //Select Currency
    document.querySelectorAll(".currency_select").forEach((el) => {
        const optionCount = el.options.length;
        $(el).select2({
            theme: "bootstrap-5",
            minimumResultsForSearch: Infinity, // hide search box
            templateResult: function (data) {
                console.log("Dropdown item data:", data.text);
                if (!data.id) return data.text;
                return $("<span>" + data.text + "</span>"); // show full text in dropdown
            },
            templateSelection: function (data) {
                if (!data.id) return data.text;

                // get the symbol from <option>
                const $option = el.querySelector(`option[value="${data.id}"]`);
                const symbol = $option?.dataset.symbol || "";

                return $("<span>" + data.text + "</span>");
            },
            dropdownCssClass: "currency-dropdown",
            selectionCssClass: "currency-selected",
        });

        // auto-select first option
        const firstVal = el.options[0]?.value;
        if (firstVal) {
            $(el).val(firstVal).trigger("change");
        }

        // // If only one option, hide arrow and prevent dropdown
        if (optionCount <= 1) {
            const select2Container = $(el).next(".select2-container");
            // hide arrow
            select2Container.find(".currency-selected").addClass("hide-arrow");
            // prevent dropdown opening if only one option
            $(el).on("select2:opening", function (e) {
                e.preventDefault();
            });
        }
    });
    //End Select Currency
});

/**
 * Defined outside the DOMContentLoaded handler so reCAPTCHA's data-callback can
 * reach it even if that handler throws before finishing. Closure variables are
 * replaced with direct lookups (window.config and document.querySelector) so
 * this can live at module scope.
 *
 **/
window.processOpenBankingPayment = function () {
    const {
        csrfToken,
        processOpenBankingRoute,
        openBankingBtnLabel,
        btnProcessingLabel,
    } = window.config;

    const btnSubmit = document.querySelector("#btnSubmit");
    const paymentFailedModalEl = document.getElementById("paymentFailedModal");
    const failureMessage =
        paymentFailedModalEl?.querySelector("#failure-message");

    const showFailure = (message) => {
        if (failureMessage) {
            failureMessage.innerHTML = message;
        }

        if (paymentFailedModalEl) {
            bootstrap.Modal.getOrCreateInstance(paymentFailedModalEl, {
                backdrop: "static",
                keyboard: false,
            }).show();
        }

        if (btnSubmit) {
            btnSubmit.disabled = false;
            btnSubmit.innerHTML = openBankingBtnLabel;
        }
    };

    if (btnSubmit) {
        btnSubmit.innerHTML = btnProcessingLabel;
        btnSubmit.disabled = true;
    }

    const form = document.querySelector("#form1");
    const formData = new FormData(form);
    const params = new URLSearchParams(formData).toString();

    fetch(processOpenBankingRoute, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-Requested-With": "XMLHttpRequest",
            "X-CSRF-TOKEN": csrfToken,
        },
        body: params,
    })
        .then((response) => response.json())
        .then((data) => {
            if (data.status === "success") {
                if (btnSubmit) {
                    btnSubmit.innerHTML = btnProcessingLabel;
                    btnSubmit.disabled = true;
                }

                window.location.href = data.redirect;
            } else {
                showFailure(data.msg);
            }
        })
        .catch(() => {
            showFailure("Something went wrong. Please try again.");
        });
};
